import { CmsObjectWithDefault } from '@components/Cms/types';

export type ForgotPasswordPhoneFormViewCmsKey =
    | 'phonenumberPlaceholder'
    | 'resetPasswordPhoneEnterPhoneButton'
    | 'ResetPasswordPhoneTitle1'
    | 'ResetPasswordPhoneTitle2';

export const ForgotPasswordPhoneFormViewCmsWithDefault: CmsObjectWithDefault<ForgotPasswordPhoneFormViewCmsKey> = {
    phonenumberPlaceholder: {
        cmsId: 82026,
        defaultTranslation: 'Mobile number',
    },
    resetPasswordPhoneEnterPhoneButton: {
        cmsId: 97925,
        defaultTranslation: 'Send OTP',
    },
    ResetPasswordPhoneTitle1: {
        cmsId: 82597,
        defaultTranslation: "Enter your mobile number and we'll send you a verification code to {0}",
    },
    ResetPasswordPhoneTitle2: {
        cmsId: 82598,
        defaultTranslation: 'reset your password',
    },
};
